var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createStyles, HawkinsGlobalClass, makeStyles } from '@hawkins/styles';
export function toggleButtonStyles(theme) {
    var _a, _b, _c;
    var hawkins = theme.hawkins, hawkinsUtils = theme.hawkinsUtils, hawkinsVariables = theme.hawkinsVariables;
    var compactPadding = hawkinsVariables.spacingValues.space1;
    return createStyles({
        /** Class name of the icon. */
        icon: {},
        /** Class name of the root element. */
        root: {
            // HACK(style): CSS override specificity.
            '&.Hawkins-Button': (_a = {
                    borderWidth: 0,
                    flexGrow: 1,
                    fontSize: hawkins.label.fontSize1,
                    fontWeight: hawkins.label.fontWeightBold,
                    lineHeight: hawkins.label.lineHeightRegular,
                    padding: "".concat(hawkinsVariables.spacings.space1, " ").concat(hawkinsVariables.spacings.space3)
                },
                _a["&.".concat(HawkinsGlobalClass.FOCUSABLE)] = (_b = {},
                    _b[hawkinsUtils.getFocusRingedElementSelector('&', '::after')] = __assign({ borderRadius: hawkinsVariables.borderRadius.borderRadius0 }, hawkinsUtils.getFocusRingPosition()),
                    _b),
                _a['&$rootSelected'] = {
                    backgroundColor: hawkins.state.backgroundColorSelected,
                    // For when the toggle button is also a menu trigger (e.g., an overflow menu trigger).
                    '&[aria-expanded="true"]': { backgroundColor: hawkins.state.backgroundColorSelectedHover },
                },
                _a),
        },
        /** Class name of the root element when the component is not disabled. */
        rootEnabled: {
            // HACK(style): CSS override specificity.
            '&.Hawkins-Button': (_c = {},
                _c[hawkinsUtils.getHoveredElementSelector('&')] = {
                    backgroundColor: hawkins.state.backgroundColorHover,
                    '&$rootSelected': { backgroundColor: hawkins.state.backgroundColorSelectedHover },
                },
                _c),
        },
        /** Class name of the root element when the component is compact. */
        rootCompact: {
            // HACK(style): CSS override specificity.
            '&.Hawkins-Button': {
                // TODO(style): The height of a compact `Button` is smaller than the height of a compact `ToggleButton`,
                // so the size of the `SkeletonLoader` rendered by `Button` will be incorrect for a compact `ToggleButton`.
                minHeight: hawkinsVariables.sizings.size3,
                // The `line-height` in a compact toggle button is 18px, while the compact icon height is 16px,
                // so subtract 1px from each vertical padding side to prevent a toggle button containing text
                // from always being taller than the desired `min-height` of 40px.
                padding: "".concat(compactPadding - 1, "px ").concat(compactPadding, "px"),
            },
        },
        /** Class name of the root element when the component is selected. */
        rootSelected: {},
    });
}
export var useToggleButtonStyles = makeStyles(toggleButtonStyles, { name: 'Hawkins-ToggleButton' });
